import { SideRailArticles, SocialShare } from '@we-make-websites/ui-lib';
import clsx from 'clsx';
import { useContext } from 'use-context-selector';
import { BlogArticleContext } from 'components/blogArticleProvider/BlogArticleProvider';
import { ContentSectionComponent } from 'components/contentSectionComponent/ContentSectionComponent';

import styles from './BlogArticleContent.module.scss';

export const BlogArticleContent = () => {
  const blogArticleContext = useContext(BlogArticleContext);

  if (blogArticleContext === undefined) {
    throw new Error(
      'BlogArticleContent must be used within a BlogArticleContext'
    );
  }

  const {
    title,
    categoryRef,
    content,
    articlesListing = [],
    sideRailArticles,
    isLoading,
  } = blogArticleContext;

  return (
    <>
      <div className={clsx(styles.blogArticleContent, 'container grid')}>
        <div
          className={clsx(
            styles.blogArticleContent__main,
            sideRailArticles?.length ? 'col xs4 l2-8' : 'col xs4 l2-11'
          )}
        >
          <p
            className={clsx(
              styles.blogArticleContent__category,
              'text-utility-utility-small-mobile text-utility-utility-desktop'
            )}
          >
            {categoryRef?.category}
          </p>
          <h1
            className={clsx(
              styles.blogArticleContent__title,
              'text-blog-heading-h1-mobile text-blog-heading-h1-desktop'
            )}
          >
            {title}
          </h1>

          {content}
        </div>
        <div
          className={clsx(
            styles.blogArticleContent__sideRailArticles,
            'col l10-12'
          )}
        >
          <SideRailArticles articles={sideRailArticles} />
        </div>
        <SocialShare text={title} isLoading={isLoading} placement="blog" />
      </div>
      {articlesListing.map((section, index) => {
        return (
          <div
            key={`${section?.__typename}-${index}`}
            className="content-section"
          >
            <ContentSectionComponent section={section} />
          </div>
        );
      })}
    </>
  );
};
